import React, { useEffect, useState } from 'react';
import classes from './GameBets.module.scss';
import { useTheme } from '../../utils/ThemeContext';
import { useSelector } from 'react-redux';

function GameBets({
  nightMode,
  resultPick3,
  resultLotto_5_90,
  resultLotto_4_48,
  resultLotto_6_49,
}) {
  const { theme } = useTheme();
  const draws = useSelector((state) => state.game.draws);
  const [matchedNumbers, setMatchedNumbers] = useState([]);
  const [lastProcessedResult, setLastProcessedResult] = useState(null);

  let resultNumbers = [];
  if (theme.themeName === 'lotto 5/90') {
    resultNumbers = resultLotto_5_90;
  } else if (theme.themeName === 'lotto 4/48') {
    resultNumbers = resultLotto_4_48;
  } else if (theme.themeName === 'Lotto 6/49') {
    resultNumbers = resultLotto_6_49;
  } else if (theme.themeName === 'pick 3') {
    resultNumbers = resultPick3;
  }

  useEffect(() => {
    setMatchedNumbers('');
  }, [draws]);

  useEffect(() => {
    if (
      resultNumbers.length > 0 &&
      lastProcessedResult !== resultNumbers.join(',')
    ) {
      setMatchedNumbers([]);
      setLastProcessedResult(resultNumbers.join(','));

      const currentGameDraws = draws.filter(
        (draw) => draw.gameName === theme.themeName,
      );

      if (currentGameDraws.length > 0) {
        const latestDraw = currentGameDraws[currentGameDraws.length - 1];

        const allMatchedNumbers = latestDraw.numbers.filter((num) =>
          resultNumbers.includes(num),
        );
        setMatchedNumbers(allMatchedNumbers);
      }
    } else {
    }
  }, [draws, resultNumbers, theme.themeName]);

  const getNumberColor = (number) => {
    const lastDigit = number % 10;
    const colors = [
      '#BE302B',
      '#962CB8',
      '#5BBA2F',
      '#31B6C2',
      '#3274C5',
      '#B92DBB',
      '#BDA02F',
      '#BF7E37',
      '#585858',
      '#18962E',
    ];
    return colors[lastDigit] || '#FFFFFF';
  };

  const getLatestNumbersByGameName = (gameName) => {
    const gameDraw = draws.filter((draw) => draw.gameName === gameName).pop();
    return gameDraw ? gameDraw.numbers : [];
  };

  const getLatestDrawByGameName = (gameName) => {
    return draws.filter((draw) => draw.gameName === gameName).pop() || null;
  };

  const latestNumbers = getLatestNumbersByGameName(theme.themeName);
  const latestDraw = getLatestDrawByGameName(theme.themeName);
  const hasBetsForGame = latestDraw && latestNumbers.length > 0;

  return (
    <div
      className={!hasBetsForGame ? classes.allEmptyCon : classes.allCont}
      style={{
        background: nightMode ? theme.selectedColor : theme.backgroundInside,
      }}
    >
      {!hasBetsForGame ? (
        <span className={classes.betsTitle}>No Bets Available</span>
      ) : (
        <div
          className={classes.choosenBetsContainer}
          style={{ backgroundColor: theme.backgroundTicket }}
        >
          {latestDraw && (
            <div className={classes.drawInfo}>
              <span className={classes.titleName}>
                Game Draw:{' '}
                <span className={classes.secondTitle}>
                  {latestDraw.gameName}
                </span>
              </span>
              <span className={classes.titleName}>
                ID:{' '}
                <span className={classes.secondTitle}>
                  #{latestDraw.privateId}
                </span>
              </span>
              <span className={classes.titleName}>
                Stake:{' '}
                <span className={classes.secondTitle}>
                  {latestDraw.stakeAmount}
                </span>
              </span>
            </div>
          )}
          <div className={classes.ballsContainer}>
            {latestNumbers.map((number, index) => {
              const isMatched = matchedNumbers.includes(number);
              return (
                <div
                  key={index}
                  className={`${classes.ballsStyle} ${isMatched ? classes.matched : ''}`}
                  style={{
                    backgroundColor: isMatched
                      ? 'gold'
                      : getNumberColor(number),
                    color: isMatched ? 'black' : 'white',
                  }}
                >
                  <div className={classes.circleInner}>
                    <span className={classes.textInsideCircle}>{number}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default GameBets;
